(() => {
  let opened = null;
  const close = () => {
    if (!opened) return;
    opened.classList.remove('dj-open');
    opened.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    opened = null;
    document.body.classList.remove('dj-dd-open', 'dj-dd-opening', 'dj-dd-entered', 'dj-dd-closing');
    document.documentElement.classList.remove('dj-dd-lock');
  };
  const open = (link) => {
    const item = link.parentElement;
    if (item === opened) { close(); return; }
    close();
    const nav = document.getElementById('nav');
    nav.querySelectorAll(':scope > ul > li.dj-open').forEach(el => el.classList.remove('dj-open'));
    const header = document.getElementById('header-outer');
    document.documentElement.style.setProperty('--dj-dd-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    item.classList.add('dj-open');
    link.setAttribute('aria-expanded', 'true');
    document.body.classList.remove('dj-dd-opening', 'dj-dd-entered', 'dj-dd-closing');
    document.body.classList.add('dj-dd-open');
    document.documentElement.classList.add('dj-dd-lock');
    opened = item;
  };
  const toggle = (button) => {
    const panel = button.closest('.dj-plus-group, .dj-plus-mobile-group')?.querySelector('.dj-plus-children');
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    button.querySelector('span').textContent = expanded ? '−' : '+';
  };
  window.addEventListener('pointerdown', (event) => {
    if (event.target.closest('[data-dj-plus-toggle]')) { event.stopImmediatePropagation(); return; }
    const link = event.target.closest('#nav > ul[data-type="horizontal-nav"] > .dj-plus-root > a');
    if (link) {
      event.preventDefault();
      event.stopImmediatePropagation();
      open(link);
    } else if (opened && !event.target.closest('.dj-plus-root.dj-open')) {
      close();
    }
  }, true);
  window.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dj-plus-toggle]');
    if (button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggle(button);
    } else if (event.target.closest('#nav > ul[data-type="horizontal-nav"] > .dj-plus-root > a')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && opened) {
      const link = opened.querySelector(':scope > a');
      close();
      link.focus();
    }
    const link = event.target.closest('#nav > ul[data-type="horizontal-nav"] > .dj-plus-root > a');
    if (link && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      open(link);
    }
  }, true);
  window.addEventListener('resize', close);
})();
